import { render, staticRenderFns } from "./ViewEvents.vue?vue&type=template&id=5109ba40&scoped=true"
import script from "./ViewEvents.vue?vue&type=script&lang=js"
export * from "./ViewEvents.vue?vue&type=script&lang=js"
import style0 from "./ViewEvents.vue?vue&type=style&index=0&id=5109ba40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5109ba40",
  null
  
)

export default component.exports